import { ServiceDetailPage } from './ServiceDetailPage';

export function AIServices() {
  return <ServiceDetailPage slug="ai-systems" />;
}
